<template>
	<div
		v-if="active"
		:class="`intro--${logo} ${activeClass}`"
		class="intro"
		data-cy="intro"
	>
		<div class="intro__ripple" />

		<div class="intro__logo" />
	</div>
</template>

<script>
export default {
	name: 'Intro',

	props: {
		duration: {
			type: Number,
			required: false,
			validator: duration => duration >= 0,
			default: 1000,
			description: 'Sets the duration of the Intro\'s animation',
		},

		initialActive: {
			type: Boolean,
			required: true,
			description: 'Sets whether the animation will start automatically when the Intro component mounts',
		},

		logo: {
			type: String,
			required: false,
			validator: value => [
				'centiva',
			].indexOf(value) !== -1,
			default: 'centiva',
			description: 'Sets the logo image',
		},
	},

	data() {
		return {
			active: false,
			activeClass: '',
		};
	},

	watch: {
		initialActive() {
			this.active = this.initialActive;
		},

		active() {
			if (this.active) {
				setTimeout(() => {
					this.activeClass = 'intro--ripple';

					setTimeout(() => {
						this.activeClass = 'intro--ripple';
						setTimeout(() => {
							this.active = false;
						}, 400);
						this.activeClass = 'intro--fade-out';
						setTimeout(() => {
							this.active = false;
							this.$emit('finished');
						}, 600);
					}, this.duration);
				}, this.duration);
			} else {
				this.activeClass = '';
			}
		},
	},

	mounted() {
		this.active = this.initialActive;
	},
};
</script>

<style lang="scss" src="./intro.scss" />
